import { useState } from "react";

import { AddMoreButton, SectionTitle } from "@components";
import { ContractualPosting } from "./ContractualPosting";
import { NewContractualPosting } from "./NewContractualPosting";

import { ContractualPostingType } from "@type/HRM/postings";

interface ContractualPostingPropsType {
  contractualPostingsInfo?: ContractualPostingType[];
  changeContractualPostingsInfo?: any;
  removeContractualPostingInfo?: any;
  deleteContractualPostingRequest?: boolean;
}

export const ContractualPostings = ({
  contractualPostingsInfo,
  changeContractualPostingsInfo,
  removeContractualPostingInfo,
}: ContractualPostingPropsType) => {
  const [newContractualPostingFormShow, setNewContractualPostingFormShow] =
    useState(false);
  const handleNewContractualPostingFormShow = (isShow: boolean) =>
    setNewContractualPostingFormShow(isShow);

  return (
    <div className="d-flex flex-column gap-8">
      <SectionTitle
        label="EMPLOYEE.POSTINGS_INFO.FORM.CONTRACTUAL_POSTING_INFO.HEADING"
        size="lg"
        noBorder
      />

      {contractualPostingsInfo?.map((contractualPosting, index) => (
        <ContractualPosting
          key={index}
          contractualPostingInfo={contractualPosting}
          changeContractualPostingsInfo={changeContractualPostingsInfo}
          removeContractualPostingInfo={removeContractualPostingInfo}
        />
      ))}

      {newContractualPostingFormShow ? (
        <NewContractualPosting
          handleNewContractualPostingFormShow={
            handleNewContractualPostingFormShow
          }
          changeContractualPostingsInfo={changeContractualPostingsInfo}
        />
      ) : (
        <AddMoreButton
          label="EMPLOYEE.POSTINGS_INFO.FORM.CONTRACTUAL_POSTING_INFO.ADD_MORE_BUTTON"
          clickAction={() => handleNewContractualPostingFormShow(true)}
        />
      )}
    </div>
  );
};

export default ContractualPostings;
